module.exports = __webpack_public_path__ + "static/media/metric-spaces.2b494989.md";